export default function TabPanel(){
    return {
        styleOverrides: {
            root: {
                padding: 0
            }
        }
    }
}